import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { loadingOpenOrders, toggleModal, useCredit } from "../store/common";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardText
} from "reactstrap";
import { getCurrencySign, changePaymentMethod } from "../store/common";
import { deleteCartProductByOrderType } from "../store/cart";
import Redbtn from "../molecules/components/RedBtn";
import html from "react-inner-html";
import { finalizeOrder } from "../store/cart";
import shop from "../api/shop";
import { getTranslate } from "react-localize-redux";
import { RingLoader } from "react-spinners";
import { Table } from "reactstrap";
import CartDeleteBtn from "../molecules/components/CartDeleteBtn";
import { Link } from "react-router";
import { getActiveLanguage } from "react-localize-redux";
import { loadingCustomers, storeCustomers } from "../store/customer";

const getOrderTypeName = (orderTypes, idType) => {
  const otFound = orderTypes.find(ot => Number(ot.value) === Number(idType));
  return otFound ? otFound.label : "-";
};
const summaryTable = (orders, currencySign, orderTypes, translate, userCredit, setCredit, usedCredit, isCreditAvailable) => (
  <Table>
    <thead>
      <tr>
        <th>
          {translate(
            "routes.productList.summaryContainer.open_order_table_count"
          )}
        </th>
        <th>
          {translate(
            "routes.productList.summaryContainer.open_order_table_quantity"
          )}
        </th>
        <th>
          {translate(
            "routes.productList.summaryContainer.open_order_table_price"
          )}
        </th>
        <th>
          {translate(
            "routes.productList.summaryContainer.open_order_table_posible_price"
          )}
        </th>
        <th>
          {translate(
            "routes.productList.summaryContainer.open_order_table_type"
          )}
        </th>
        {isCreditAvailable &&
          <th>
            {translate('availableCredit')}:{' '}
            {userCredit - (Object.values(usedCredit).length > 0 ? Object.values(usedCredit).reduce((total, amount) => { return total + amount; }) : 0)}
          </th>
        }
      </tr>
    </thead>
    <tbody>
      {orders &&
        orders.map(o => (
          <tr>
            <td>{o.items || 0}</td>
            <td>{o.total_quantity || 0}</td>
            <td>
              {parseFloat(o.total_price - (+usedCredit[o.id_o_type] || 0)).toFixed(2)} {currencySign}
            </td>
            <td>
              {parseFloat(o.posible_price - (+usedCredit[o.id_o_type] || 0)).toFixed(2)} {currencySign}
            </td>
            <td>
              {translate(
                `routes.customerList.customerActionRow.action_${getOrderTypeName(
                  orderTypes,
                  o.id_o_type
                )}`
              )}
            </td>
            {isCreditAvailable &&
              <td>
                <div className="cartBar__credit">
                  <input
                    type="number"
                    min={0}
                    max={userCredit < Math.floor(o.total_price) ? userCredit : Math.floor(o.total_price)}
                    value={usedCredit[o.id_o_type]}
                    onChange={e => {
                      const max = userCredit < Math.floor(o.total_price) ? userCredit : Math.floor(o.total_price);
                      const value = +e.target.value;
                      if (value <= +max && value >= 0) {
                        setCredit({ [o.id_o_type]: +e.target.value });
                      }

                      e.stopPropagation();
                    }}
                    placeholder={translate(
                      'containers.cart.cartContainer.credit_placeholder',
                    )}
                    aria-label="credit"
                    aria-describedby="credit"
                  />
                  <button
                    tabIndex="-1"
                    className="cartBar__credit__button"
                    type="submit"
                    onClick={() => {
                      //setCredit(usedCredit); 
                    }}
                  >
                    {translate('containers.cart.cartContainer.credit_use_btn')}
                  </button>
                </div>
              </td>
            }
          </tr>
        ))}
    </tbody>
  </Table >
);

const getAlternativeURL = code => {
  const codeParts = code.split("-");
  return (
    "/products/category/" +
    codeParts[0] +
    "/brand/" +
    codeParts[2] +
    "/model/" +
    codeParts[3]
  );
};

const unAvailableItemsTable = (
  items,
  orderTypes,
  translate,
  deleteItemFromCart,
  toggleModal,
  currentLanguage
) => (
    <Table>
      <thead>
        <tr>
          <th>
            {translate(
              "routes.productList.summaryContainer.open_order_unavailable_flex"
            )}
          </th>
          <th>
            {translate(
              "routes.productList.summaryContainer.open_order_unavailable_code"
            )}
          </th>
          <th>
            {translate(
              "routes.productList.summaryContainer.open_order_unavailable_cart"
            )}
          </th>
          <th>
            {translate(
              "routes.productList.summaryContainer.open_order_unavailable_quantity"
            )}
          </th>
          <th>
            {translate(
              "routes.productList.summaryContainer.open_order_unavailable_otype"
            )}
          </th>
          <th>
            {translate(
              "routes.productList.summaryContainer.open_order_unavailable_alternative"
            )}
          </th>
        </tr>
      </thead>
      <tbody>
        {items &&
          items.map(i => (
            <tr>
              <td>{i.flex_name || "-"}</td>
              <td>{i.code || "-"}</td>
              <td>{i.cart_quantity}</td>
              <td>{i.store_quantity}</td>
              <td>
                {translate(
                  `routes.customerList.customerActionRow.action_${getOrderTypeName(
                    orderTypes,
                    i.id_o_type
                  )}`
                )}
              </td>
              <td>
                <Link to={getAlternativeURL(i.code)}>
                  <Button
                    onClick={() =>
                      toggleModal("submit_opened_order_modal", false)
                    }
                  >
                    {translate(`alternative`)}
                  </Button>
                </Link>
              </td>
              <td>
                <CartDeleteBtn
                  title=""
                  deleteCartProduct={() =>
                    deleteItemFromCart(
                      i.id_product,
                      getOrderTypeName(orderTypes, i.id_o_type)
                    )
                  }
                />
              </td>
            </tr>
          ))}
      </tbody>
    </Table>
  );

class SubmitOpenedOrderModal extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      getModalStatus,
      toggleModal,
      finishOrder,
      OzMessage,
      CustomerMessage,
      customerId,
      translate,
      isOpenOrdersLoading,
      openOrders,
      currencySign,
      orderTypes,
      payments,
      changePaymentMethod,
      getUserPaymentMethod,
      unavailableItems,
      deleteItemFromCart,
      currentLanguage,
      userCredit,
      currentOZ,
      isCreditAvailable
    } = this.props;

    const usedCredit = { ...this.state };

    const setCredit = (data) => {
      this.setState(prevState => ({ ...prevState, ...data }));
    }

    const reset = () => {
      const s = { ...this.state };
      Object.keys(s).forEach(skey => this.setState({ [skey]: 0 }))
    }


    return (

      <Modal
        size="lg"
        className=""
        isOpen={getModalStatus}
        toggle={() => toggleModal("submit_opened_order_modal", false)}
        backdrop={false}
        centered
        modalClassName={"modal_box_shadow"}
        unmountOnClose
        onOpened={reset}
        onClosed={reset}
      >
        <ModalHeader>
          {" "}
          <h1>{translate("containers.cart.cartContainer.payments")}</h1>
        </ModalHeader>
        <ModalBody>
          {isOpenOrdersLoading && (
            <div className="spinner">
              <RingLoader
                color={"#d42e2b"}
                loading={isOpenOrdersLoading}
                size={120}
                margin={20}
              />
            </div>
          )}
          {!isOpenOrdersLoading &&
            openOrders &&
            openOrders.length > 0 &&
            summaryTable(openOrders, currencySign, orderTypes, translate, userCredit, setCredit, usedCredit, isCreditAvailable)}


          {!isOpenOrdersLoading && unavailableItems && unavailableItems.length > 0 && (
            <Card body inverse color="danger">
              <CardTitle>
                {translate(
                  "routes.productList.summaryContainer.open_order_unavailable_title"
                )}
              </CardTitle>
              <CardText>
                {translate(
                  "routes.productList.summaryContainer.open_order_unavailable_text"
                )}
              </CardText>
              <br />
              {unAvailableItemsTable(
                unavailableItems,
                orderTypes,
                translate,
                deleteItemFromCart,
                toggleModal,
                currentLanguage
              )}
            </Card>
          )}

          <br />
          {!isOpenOrdersLoading && openOrders && openOrders.length > 0 && (
            <div className="container mt-3 mb-3">
              <div className="row">
                <div className="col-12 pt-4 pb-4 bg-light">
                  <h4>{translate("containers.cart.cartContainer.payments")}</h4>
                </div>
                {payments &&
                  payments.map(payment => (
                    <div className="col-12 col-md-3  pt-4 pb-4  bg-light">
                      <div className="form-check">
                        <input
                          key={payment.id}
                          className="form-check-input"
                          type="radio"
                          name="inlineRadioOptionsForPayment"
                          value={payment.id}
                          id={"paymentCheck" + payment.id}
                          onChange={e => {
                            changePaymentMethod(e.target.value);
                          }}
                          defaultChecked={getUserPaymentMethod === payment.id}
                          checked={getUserPaymentMethod === payment.id}
                        />
                        <label
                          className="form-check-label"
                          htmlhtmlFor={"paymentCheck" + payment.id}
                          onClick={() => changePaymentMethod(payment.id)}
                        >
                          <strong>
                            {translate(
                              `routes.productList.summaryContainer.open_order_payment_${payment.slug
                              }`
                            )}
                          </strong>
                        </label>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
          <Card>
            <CardHeader>
              {translate("containers.orderNotificationModal.reminder_customer")}
            </CardHeader>
            <CardBody>
              <CardText {...html(CustomerMessage)} />
            </CardBody>
          </Card>
          <br />
          <Card>
            <CardHeader>
              {translate("containers.orderNotificationModal.reminder_oz")}
            </CardHeader>
            <CardBody>
              <CardText {...html(OzMessage)} />
            </CardBody>
          </Card>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => toggleModal("submit_opened_order_modal", false)}
          >
            {translate("containers.orderNotificationModal.close")}
          </Button>
          {openOrders && openOrders.length > 0 && (
            <Redbtn
              icon="fa fa-shopping-cart"
              title={translate("containers.orderNotificationModal.finish")}
              action={() => {
                reset();
                finishOrder(customerId, usedCredit, currentOZ);
              }
              }
            />
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

SubmitOpenedOrderModal.propTypes = {};

const mapStateToProps = ({ common, cart, customer, locale }) => ({
  translate: getTranslate(locale),
  currentLanguage: getActiveLanguage(locale).id || 1,
  currencySign: getCurrencySign(common.user.currency.sign),
  getModalStatus: common.modals.submit_opened_order_modal
    ? common.modals.submit_opened_order_modal
    : null,
  OzMessage: common.oz.oz && common.oz.oz.message,
  CustomerMessage: common.user.message,
  customerId: common.user.personal.id,
  isOpenOrdersLoading: common.openOrdersLoading,
  openOrders: common.openOrdersList || [],
  orderTypes: common.orderTypes,
  getUserPaymentMethod: common.user.payment,
  payments: common.user.paymentMethods,
  unavailableItems: common.unavailableItems || [],
  userCredit: common.user.credit,
  currentOZ: common.oz.id,
  isCreditAvailable: common.user.shippingAddress.country === 'Slovakia'
});

const mapDispatchToProps = dispatch => ({
  toggleModal: (modalName, action) => dispatch(toggleModal(modalName, action)),
  deleteItemFromCart: (itemId, orderType) =>
    dispatch(deleteCartProductByOrderType(itemId, orderType)),
  finishOrder: (id, usedCredit, ozId) => {
    dispatch(loadingOpenOrders(true));
    shop.submitOpenedOrder(id, { credit: usedCredit }, orderDataFromApi => {
      dispatch(useCredit(Object.values(usedCredit).length > 0 ? Object.values(usedCredit).reduce((total, amount) => { console.log(amount); return total + amount; }) : 0));
      orderDataFromApi.then(() => {
        dispatch(loadingCustomers(true));
        shop.getCustomers(ozId, customersPromise => {
          customersPromise.then(customers => {
            dispatch(storeCustomers(customers));
            dispatch(loadingCustomers(false));
          });
        });
        dispatch(finalizeOrder(true));
        dispatch(loadingOpenOrders(false));
        dispatch(toggleModal("submit_opened_order_modal", false));
        dispatch(toggleModal("order_confirmation_successful", true));
      });
    });
  },
  changePaymentMethod: paymentId => dispatch(changePaymentMethod(paymentId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmitOpenedOrderModal);



// WEBPACK FOOTER //
// ./src/containers/SubmitOpenedOrderModal.js